import { ProductionClass } from '../production.class';
import * as Constants from '../../globals/constants';
import { ResourceService } from '../../services/resource.service';
import { PopulationService } from '../../services/population.service';
import { TechnologyService } from '../../services/technology.service';

/**
 * @internal
 * The isolateExtension allows the user to isolate current selection in the viewer.
 */
export class Powerplant extends ProductionClass {

  /**
   * @ignore
   */
  constructor(resourceHandler: ResourceService, populationService: PopulationService, technologyService: TechnologyService) {
    super(resourceHandler, populationService, technologyService);
    this.initBuilding('Power plant', 'powerplant', Constants.SETTINGS.BUILDING_SETTINGS.POWER_PLANT);
  }

  public produce(timePassed) {
    super.produce(timePassed);
    this.produced.power *= 2.5;
  }

  public resourcesProduced() {
    if (this.produced.power > 1) {
      const produced = Math.floor(this.produced.power);
      this.produced.power -= produced;
      this.resourceService.addResource('power', produced);
    }
    const maxPower = Math.floor(this.productionPerMinute.power * this.numberOfBuildings * this.reseachMultiplier);
    if (this.resourceService.getResource('power') > maxPower) {
      this.resourceService.setResource('power', maxPower);
    }
  }


  public setResearchBonus() {
    const additiveMultiplier = [];
    const multiplicativeMultiplier = [];



    if (this.technologyService.state.fusion_energy) {
      additiveMultiplier.push(.05);
    }

    if (this.technologyService.state.zero_point_energy) {
      additiveMultiplier.push(.15);
    }

    const amResult = additiveMultiplier.reduce((a, b) => a + b, 1);
    const mmResult = multiplicativeMultiplier.reduce((a, b) => a * (1 + b), 1);

    this.reseachMultiplier = 1 * amResult * mmResult;
  }

  public unlock() {
    return this.technologyService.state.power_plants;
  }

}
